var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n  Automated Investing\n  "),(_vm.aiEnabled)?_c('span',{staticClass:"badge badge-success"},[_vm._v("On")]):_c('span',{staticClass:"badge badge-warning"},[_vm._v("Off")])])}
var staticRenderFns = []

export { render, staticRenderFns }